import { useState } from 'react'
import { api, can, refusalReason, type Vendor } from '../../lib/api'
import { noteRecordDiffers } from '../../lib/dateRules'

// One contract-end source (release 3.3, the plan's C13). The vendor's
// contract dates are the filed contract's (the MSA, else the SOW) where one is
// filed, and the record's otherwise: the server decides it once
// (repo/contract_dates.go) and sends both sides as vendor.contract. Where the
// record says something else, the note D10 says what it says, and "Update the
// record" writes the filed contract's dates into it, an ordinary edit with its
// evidence row. Nothing is written without a person pressing it.

// contractDates is what a screen shows for "the contract".
export function contractDates(v: Vendor): { start?: string; end?: string; source?: string } {
  if (v.contract) return { start: v.contract.start, end: v.contract.end, source: v.contract.source }
  return { start: v.contractStartDate, end: v.contractEndDate, source: v.contractStartDate || v.contractEndDate ? 'RECORD' : undefined }
}

export function RecordDiffersNote({ vendor }: { vendor: Vendor }) {
  const c = vendor.contract
  const [state, setState] = useState<'idle' | 'busy' | 'done' | 'failed'>('idle')
  const note = c ? noteRecordDiffers(c.recordStart ?? '', c.recordEnd ?? '', c.filedFrom ?? '', c.filedEnd ?? '') : ''
  if (!c || !note) return null
  if (state === 'done') {
    return (
      <p className="cell-sub" role="status">
        The record now says what the filed {c.kind} says.
      </p>
    )
  }
  const allowed = can('vendor.edit')
  function update() {
    if (!c) return
    const changes: Record<string, string> = {}
    if (c.filedFrom) changes.contractStartDate = c.filedFrom
    if (c.filedEnd) changes.contractEndDate = c.filedEnd
    setState('busy')
    api
      .updateVendor(vendor.id, changes)
      .then(() => setState('done'))
      .catch(() => setState('failed'))
  }
  return (
    <p className="cell-sub" role="note" data-testid="contract-record-differs">
      {note}{' '}
      <button
        type="button"
        className="linkish"
        onClick={update}
        disabled={state === 'busy' || !allowed}
        title={allowed ? undefined : refusalReason('vendor.edit')}
      >
        Update the record
      </button>
      {state === 'failed' && <span className="field-error"> Not saved. Try again.</span>}
    </p>
  )
}
